<template>
  <div class="button-container">

    <template v-if="file">
      <a 
        v-if="file.is_available"
        :href="`/download/${base64Encode(file.id)}`"
        target="_blank"
        download
        class="button"
        >
        
        <div class="label">
          <div class="download-icon">
            <i class="fal fa-cloud-download-alt"></i>
          </div>

          {{ label ? label : file.file_name }}
        </div>

        <div class="icon">
          <i 
            class="fal"
            :class="[`fa-${icon}`]"
            />
        </div>
      </a>

      <Placeholder
        v-else
        :message="emptyText"
        />

    </template>

    <a 
      v-else
      :href="download"
      download
      class="button"
      >
      
      <div class="label">
        <div class="download-icon">
          <i class="fal fa-cloud-download-alt"></i>
        </div>

        {{ label }}
      </div>

      <div class="icon">
        <i 
          class="fal"
          :class="[`fa-${icon}`]"
          />
      </div>
    </a>

  </div>
</template>

<script>

import { Link } from '@inertiajs/inertia-vue3'

import Placeholder from '@/Components/Placeholder'

export default {
  components: {
    Link,
    Placeholder
  },
  props: {
    label: String,
    icon: String,
    download: String,
    file: [Boolean, Array, Object, String],
    emptyText: {
      type: String,
      default: 'Your treatment plan will be available shortly. Please come back soon to access it.'
    }
  },
  methods: {
    base64Encode(string){
      let value = String(string)
      if (process.client) {
        return window.btoa(unescape(encodeURIComponent(value)))
      } else {
        return Buffer.from(value, 'ascii').toString('base64')
      }
    },
  }
}
</script>

<style lang="sass" scoped>

$regular-height: 80px
$small-height: 60px

.button-container

  .button
    box-shadow: 0 2px 9px rgba(#000, 0.1)
    min-height: $regular-height
    display: grid
    border-radius: 6px
    overflow: hidden
    align-items: center
    justify-content: start
    transition: all 300ms
    width: 100%
    cursor: pointer
    background-color: #fff
    position: relative
    grid-template-columns: 1fr 80px

    @media (max-width: 768px)
      grid-template-columns: 1fr 60px
      min-height: $small-height

    &:hover
      background-color: rgba(#70C2FF, 0.1)

    .label
      padding: 8px 20px
      font-weight: 700
      font-size: 16px
      font-family: 'Roboto', sans-serif
      display: flex
      align-items: center
      min-height: $regular-height
      height: 100%
      text-transform: capitalize
      color: #222
      // white-space: nowrap
      text-align: left
      width: 100%
      justify-content: flex-start
      line-height: 1

      .download-icon
        padding-right: 20px
        font-size: 22px

      @media (max-width: 768px)
        min-height: $small-height
        padding: 8px 15px
        font-size: 14px

        .download-icon
          padding-right: 10px
          font-size: 18px

    .icon
      height: 100%
      border-left-width: 1px
      border-right-style: solid
      border-left-color: #e9e9e9
      min-height: $regular-height
      display: flex
      align-items: center
      justify-content: center
      width: $regular-height
      font-size: 38px
      background-color: rgba(#70C2FF, 1)
      color: #fff

      i
        -webkit-font-smoothing: antialiased
        -moz-osx-font-smoothing: grayscale

      @media (max-width: 768px)
        width: 60px
        font-size: 26px
        min-height: $small-height
        width: $small-height


</style>